
export default class SearchCommon {
    constructor() {
    }

    renderPagination(renderOptions, isFirstRender) {
        const {
            pages,
            currentRefinement,
            nbPages,
            isFirstPage,
            isLastPage,
            refine,
            createURL,
        } = renderOptions;

        const container = document.querySelector('#pagination');

        console.log(pages.length);
        if (pages.length<=1) {
          container.innerHTML = '';
        } else {
        container.innerHTML = `
    <div class="ais-Pagination">
    <ul class="ais-Pagination-list">
        ${
            //!isFirstPage
            //?
            `
              <li class="ais-Pagination-item ais-Pagination-item--previousPage">
                <a
                  href="${createURL(currentRefinement - 1)}"
                  data-value="${currentRefinement - 1}"
                  class="ais-Pagination-link" aria-label="Previous" 
                >
                    <span class="ais-Pagination-link" aria-label="Previous">
                        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21.1528 16.3536C21.348 16.1583 21.348 15.8417 21.1528 15.6464L17.9708 12.4645C17.7755 12.2692 17.4589 12.2692 17.2637 12.4645C17.0684 12.6597 17.0684 12.9763 17.2637 13.1716L20.0921 16L17.2637 18.8284C17.0684 19.0237 17.0684 19.3403 17.2637 19.5355C17.4589 19.7308 17.7755 19.7308 17.9708 19.5355L21.1528 16.3536ZM11.1992 16.5H20.7992V15.5L11.1992 15.5V16.5Z"
                            fill="#222628"
                        />
                        </svg>
                    </span>
                </a>
              </li>
              `
            //: ''
            }
        ${pages
                .map(
                    page => `
              <li class="ais-Pagination-item ais-Pagination-item--page">
                <a
                  href="${createURL(page)}"
                  data-value="${page}"
                  style="font-weight: ${currentRefinement === page ? 'bold' : ''}"
                  class="ais-Pagination-link" aria-label="Page ${page + 1}" 
                                  >
                  ${page + 1}
                </a>
              </li>
            `
                )
                .join('')}
          ${
            //!isLastPage
            //? 
            `
                <li class="ais-Pagination-item ais-Pagination-item--nextPage">
                  <a
                    href="${createURL(currentRefinement + 1)}"
                    data-value="${currentRefinement + 1}"
                    class="ais-Pagination-link" aria-label="Next"
                  >
                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21.1528 16.3536C21.348 16.1583 21.348 15.8417 21.1528 15.6464L17.9708 12.4645C17.7755 12.2692 17.4589 12.2692 17.2637 12.4645C17.0684 12.6597 17.0684 12.9763 17.2637 13.1716L20.0921 16L17.2637 18.8284C17.0684 19.0237 17.0684 19.3403 17.2637 19.5355C17.4589 19.7308 17.7755 19.7308 17.9708 19.5355L21.1528 16.3536ZM11.1992 16.5H20.7992V15.5L11.1992 15.5V16.5Z"
                        fill="#222628"
                    />
                    </svg>
                  </a>
                </li>
                `
            //: ''
            }
      </ul>
      </div>
    `;

        [...container.querySelectorAll('a')].forEach(element => {
            element.addEventListener('click', event => {
                let searchElement = document.getElementById('resources-search');
                if (searchElement == null) {
                  searchElement = document.getElementById('full-site-search');
                }
                if (searchElement != null) {
                    let header = document.getElementsByTagName('header')[0];
                    header.style.display = 'none';
                    searchElement.scrollIntoView(true);
                    setTimeout(function () {
                        let header = document.getElementsByTagName('header')[0];
                        header.classList.remove('headroom--pinned');
                        header.classList.add("headroom--unpinned");
                        header.style.display = 'block';
                    }, 500);
                }
                event.preventDefault();
                refine(event.currentTarget.dataset.value);
            });
        });
      }
    };

    renderPageString(page, hitsPerPage, nbHits) {
        if (nbHits > 0) {
            let currentIdx = page * hitsPerPage + 1;
            let pageMax = hitsPerPage;
            if (nbHits < hitsPerPage) {
                pageMax = nbHits;
            }
            return currentIdx + "-" + pageMax + " of " + nbHits + " results";
        }
        return "No results"
    }
}
